import React, { type FC } from "react";
import { WelcomePopup } from "@components/User/WelcomePopup";
import { USER_VERIFICATION_MODAL } from "clientState/ab/features";
import { createFeature, Desktop } from "@edreamsodigeo/frontend-core";

import type { UserVerificationManagerProps } from "./contract";
import UserVerificationManager from "./UserVerificationManager";

const WelcomePopupForDesktop: FC = () => (
  <Desktop>
    <WelcomePopup />
  </Desktop>
);

const UserVerificationManagerVersioned =
  createFeature<UserVerificationManagerProps>({
    name: USER_VERIFICATION_MODAL,
    variations: [WelcomePopupForDesktop, UserVerificationManager],
    version: 1,
  });

export default UserVerificationManagerVersioned;
